import { Get, Post, PostFormData, Put } from "../Request/Api";

export default {
  state: {
    Currencies: [],
  },
  getters: {
    GetCurrencies(state:any) {
        return state.Currencies;
      },
  },
  actions: {
    async GetCurrencies({ commit }:any, payload:any) {
        return Get(`Currency/GetCurrencies`).then((res:any) => {
          commit("SetCurrencies", res.data.Data);
          return res.data;
        });
      },
  },
  mutations: {
    SetCurrencies(state: any, payload: any) {
      const uniqueCurrencies = payload.filter((currency: any, index: number, self: any[]) =>
          index === self.findIndex((c) => c.CurrencyCode === currency.CurrencyCode)
      );
      state.Currencies = uniqueCurrencies;
  },
  
  },
};
